import { RollingStartEndpointBuilder } from "@src/services/rollingStartApi/apiTypes";
import {
  IDiscountKxm,
  IDiscountNudgeVAE,
  IDiscountProductOffered,
} from "../DiscountProduct.interface";

export const createDiscountProductEndpoints = (
  builder: RollingStartEndpointBuilder
) => ({
  getDiscountProductOffered: builder.query<IDiscountProductOffered[], void>({
    query: () => ({
      url: "/discountoffered",
    }),
  }),
  getDiscountKxm: builder.query<IDiscountKxm[], void>({
    query: () => ({
      url: "/discountkxm",
    }),
  }),
  getDiscountNudgeVAE: builder.query<IDiscountNudgeVAE[], void>({
    query: () => ({
      url: "/discountnudgevae",
    }),
  }),
});
